$bog_bzrl_app_slider_dot $mol_button_minor
	attr *
		^
		bog_bzrl_app_slider_dot_active <= active false

$bog_bzrl_app_slider $mol_view
	sub /
		<= Prev $mol_button_minor
			click? <=> prev? null
			sub / <= Prev_icon $mol_icon_chevron_left
		<= Slides $mol_view
			sub /
				<= Slide $mol_image
					uri <= current_slide_uri \
		<= Next $mol_button_minor
			click? <=> next? null
			sub / <= Next_icon $mol_icon_chevron_right
		<= Dots $mol_view
			sub <= dots /
				<= Dot* $bog_bzrl_app_slider_dot
					active <= dot_active* false
					click? <=> dot_select*? null
